// extracted by mini-css-extract-plugin
export var button = "_dh-0";
export var icon = "_dh-1";